export default __webpack_public_path__ + "static/shop-image7-8d38281540d59850657f813332c907ee.jpg";